export { TripDetailModel } from './TripDetail.model';
export { TripModel } from './Trip.model';
